import taskApi from 'components/tasks/api';
import {
  retrieveTasks,
  setTasks
} from './search';

import { changeSelectedTasks } from './select_list';
import { toggleAlert } from './ui';
import { post } from 'helpers/api';

export function addTask(taskData, onSuccess, onError) {
  return (dispatch, getState) => {
    taskApi.addTask(taskData, true).then((response) => {
      const tasks = [...getState().search.tasks, response];
      dispatch(setTasks(tasks));
      if (onSuccess)  onSuccess(response);
    }).catch((errors) => {
      if (onError)  onError(errors);
    });
  };
}

export function updateTask(taskData, onSuccess, onError) {
  return (dispatch) => {
    taskApi.updateTask(taskData, true).then((response) => {
      dispatch(retrieveTasks());
      if (onSuccess)  onSuccess(response);
    }).catch((errors) => {
      if (onError)  onError(errors);
    });
  };
}

export function deleteTask(taskData) {
  return (dispatch) => {
    taskApi.removeTask(taskData).then(() => {
      dispatch(retrieveTasks());
    });
  };
}

export const START_BULK_DELETE_TASKS = 'START_BULK_DELETE_TASKS';
export function startBulkDeleteTasks() {
  return { type: START_BULK_DELETE_TASKS };
}

export const END_BULK_DELETE_TASKS = 'END_BULK_DELETE_TASKS';
export function endBulkDeleteTasks() {
  return { type: END_BULK_DELETE_TASKS };
}

export const START_BULK_REMOVE_TASKS = 'START_BULK_REMOVE_TASKS';
export function startBulkRemoveTasks() {
  return { type: START_BULK_REMOVE_TASKS };
}

export const END_BULK_REMOVE_TASKS = 'END_BULK_REMOVE_TASKS';
export function endBulkRemoveTasks() {
  return { type: END_BULK_REMOVE_TASKS };
}

export function bulkDeleteTasks() {
  return (dispatch, getState) => {
    const deletePath = getState().paths.bulkDeleteTasks;
    const callIds = getState().selectList.selectedTaskIds;

    post(deletePath, { taskIds: callIds }).then(({ message, error }) => {
      dispatch(endBulkDeleteTasks());
      dispatch(retrieveTasks());
      dispatch(toggleAlert(message, error));
      dispatch(changeSelectedTasks([]));
    });
  };
}

export function bulkRemoveTasks() {
  return (dispatch, getState) => {
    const callListsPath = getState().paths.callLists;
    const activeCallListId = getState().query.callListId;
    const callIds = getState().selectList.selectedTaskIds;
    const removePath = `${callListsPath}/${activeCallListId}/bulk_remove`;

    post(removePath, { taskIds: callIds }).then(({ message, error }) => {
      dispatch(endBulkRemoveTasks());
      dispatch(retrieveTasks());
      dispatch(toggleAlert(message, error));
      dispatch(changeSelectedTasks([]));
    });
  };
}

export function toggleTaskState(taskData) {
  return (dispatch, getState) => {
    const newTask = { ...taskData };
    newTask.completed = !taskData.completed;
    return taskApi.updateTask(newTask).then((result) => {
      const [...tasks] = getState().search.tasks;
      const task = tasks.find(el => el.id === result.id);

      task.completed = result.completed;
      task.completedAt = result.completedAt;

      tasks[tasks.findIndex(el => el.id === result.id)] = task;
      dispatch(setTasks(tasks));
    });
  };
}
